import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgOilCaneIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M54.062 18.556c1.071 0 1.938-.749 1.938-1.67V9.67C56 8.748 55.133 8 54.062 8H9.938C8.867 8 8 8.748 8 9.67v7.215c0 .922.867 1.67 1.938 1.67h1.313v8.752h-.548c-1.058 0-1.925.747-1.925 1.67v6.08c.013.915.867 1.652 1.925 1.67h.548v9.252H9.938c-1.071 0-1.938.748-1.938 1.67v6.682C8 55.253 8.867 56 9.938 56h44.124C55.133 56 56 55.253 56 54.33v-6.68c0-.923-.867-1.671-1.938-1.671h-1.275v-9.252h.855c1.07 0 1.937-.748 1.937-1.67v-6.08c0-.923-.867-1.67-1.937-1.67h-.855v-8.751zM11.863 11.34h40.274v3.341H11.863zm3.251 34.806v-9.42h33.81v9.32zm36.59-15.499v2.74H12.64v-2.74zm-36.59-3.34V18.19h33.81v9.219zm-3.251 25.22v-3.34h40.121v3.14z"
    />
  </svg>
)
export default SvgOilCaneIcon
